import React from 'react'

const Profiledetails = ({ isActiveTab, data }) => {
    return (
        <div className={`ContainerTabForAllTabData tabWrapper ${isActiveTab && 'active'}`}>
            <div className="Headingforallheader">
                <div className="flex-between w-100">
                    <h2 className="heading-2">Profile Details</h2>
                </div>
            </div>

            <div className="border-btm w-100"></div>

            <div className="bodyDataForallUserdata Adfixwidthalldata">
                <div className="profileDetailsWrap">
                    <div className="profileDetails flexbox">
                        <div className="profileOptions Addatasetwidth">
                            First Name
                        </div>
                        <div className="profileData AdAnssetwidth">
                            {data?.firstName ? data?.firstName : "---"}
                        </div>
                    </div>
                    <div className="profileDetails flexbox">
                        <div className="profileOptions Addatasetwidth">
                            Last Name
                        </div>
                        <div className="profileData AdAnssetwidth">
                            {data?.lastName ? data?.lastName : "---"}
                        </div>
                    </div>

                    <div className="profileDetails flexbox">
                        <div className="profileOptions Addatasetwidth">
                            Phone Number
                        </div>
                        <div className="profileData AdAnssetwidth">
                            {data?.mobileNumber ? data?.mobileNumber : "---"}
                        </div>
                    </div>
                    <div className="profileDetails flexbox">
                        <div className="profileOptions Addatasetwidth">
                            Email
                        </div>
                        <div className="profileData AdAnssetwidth">
                            {data?.email ? data?.email : "---"}
                        </div>
                    </div>
                    <div className="profileDetails flexbox">
                        <div className="profileOptions Addatasetwidth">
                            Qualification Level
                        </div>
                        <div className="profileData AdAnssetwidth">
                            {data?.profession?.title ? data?.profession?.title === "student" ? "Student" : 'Working Professional' : "---"}
                        </div>
                    </div>
                    <div className="profileDetails flexbox">
                        <div className="profileOptions Addatasetwidth">
                            {data?.profession?.title === "student" ? 'Qualification' : "Professional"} Domain
                        </div>
                        <div className="profileData AdAnssetwidth">
                            {data?.profession?.company ? data?.profession?.company : "---"}
                        </div>
                    </div>
                    <div className="profileDetails flexbox">
                        <div className="profileOptions Addatasetwidth">
                            {data?.profession?.title === "student" ? 'Year of Study' : 'Working Experience'}
                        </div>
                        <div className="profileData AdAnssetwidth">
                            {data?.profession?.yrsOfExp ? `${data?.profession?.yrsOfExp}+ years` : "---"}
                        </div>
                    </div>
                </div>

            </div>

        </div>
    )
}

export default Profiledetails
